(() => {
  if (customElements.get('bellwove-product-gallery')) return;

  class BellwoveProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.slides = Array.from(this.querySelectorAll('.bw-product-gallery__slide'));
      this.controls = this.querySelector('.bw-product-gallery__thumbnails');
      if (this.slides.length < 2 || !this.controls || !this.id) return;
      if (this.slides.some((slide) => !slide.id || !slide.querySelector('img'))) return;

      this.buttons = this.slides.map((slide, index) => {
        const original = slide.querySelector('img');
        const button = document.createElement('button');
        const thumbnail = document.createElement('img');

        button.type = 'button';
        button.className = 'bw-product-gallery__thumbnail';
        button.id = `${this.id}-thumbnail-${index + 1}`;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', slide.id);
        button.setAttribute('aria-label', `View image ${index + 1}${original.alt ? `: ${original.alt}` : ''}`);
        thumbnail.src = slide.dataset.galleryThumbnail || original.currentSrc || original.src;
        thumbnail.alt = '';
        thumbnail.width = 96;
        thumbnail.height = 96;
        thumbnail.decoding = 'async';
        thumbnail.setAttribute('aria-hidden', 'true');
        button.appendChild(thumbnail);

        slide.setAttribute('role', 'tabpanel');
        slide.setAttribute('aria-labelledby', button.id);
        slide.tabIndex = 0;
        button.addEventListener('click', () => this.select(index));
        button.addEventListener('keydown', (event) => this.onKeydown(event, index));
        return button;
      });

      this.controls.setAttribute('role', 'tablist');
      this.controls.setAttribute('aria-label', 'Product images');
      this.controls.setAttribute('aria-orientation', 'horizontal');
      this.buttons.forEach((button) => this.controls.appendChild(button));
      this.select(0);
      this.classList.add('is-enhanced');
      this.controls.hidden = false;
      this.initialized = true;
    }

    select(index, moveFocus = false) {
      if (index < 0 || index >= this.slides.length) return;

      this.slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === index;
        slide.hidden = !selected;
        this.buttons[slideIndex].setAttribute('aria-selected', String(selected));
        this.buttons[slideIndex].tabIndex = selected ? 0 : -1;
      });

      if (moveFocus) this.buttons[index].focus();
    }

    onKeydown(event, index) {
      const lastIndex = this.slides.length - 1;
      const isRtl = getComputedStyle(this.controls).direction === 'rtl';
      let nextIndex;

      if (event.key === 'ArrowRight') nextIndex = (index + (isRtl ? lastIndex : 1)) % this.slides.length;
      else if (event.key === 'ArrowLeft') nextIndex = (index + (isRtl ? 1 : lastIndex)) % this.slides.length;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = lastIndex;
      else return;

      event.preventDefault();
      this.select(nextIndex, true);
    }
  }

  customElements.define('bellwove-product-gallery', BellwoveProductGallery);
})();
